export default "__VITE_ASSET__DA3E6obL__"